export const DONATE = "https://buymeacoffee.com/chase8";
export const OPEN_DOG_REGISTRY = "https://open-dog-registry.web.app/";
export const DOGMATCH_GITHUB = "https://github.com/chase-manning/dogmatch/";
export const DOGMATCH_CONTRIBUTE = `${DOGMATCH_GITHUB}blob/main/.github/CONTRIBUTING.md`;
export const DOGMATCH_LICENSE = `${DOGMATCH_GITHUB}blob/main/LICENSE`;
export const API_GITHUB = "https://github.com/chase-manning/open-dog-registry/";
export const API_CONTRIBUTE = `${API_GITHUB}blob/main/.github/CONTRIBUTING.md`;
